import { twMerge } from 'tailwind-merge';
import type { HTMLAttributes } from 'react';

type PreviewContainerProps = HTMLAttributes<HTMLDivElement> & {
  open: boolean;
};

export const PreviewContainer = ({ className, open, ...props }: PreviewContainerProps) => (
  <div
    className={twMerge(
      `w-auto flex overflow-x-hidden whitespace-nowrap items-center ${open ? 'opacity-100' : 'opacity-0'} ${open ? 'max-w-[236px]' : 'max-w-0'} ${open ? 'ml-4' : 'ml-0'} ${open ? 'pl-4' : 'pl-0'} transition-all border-solid border-base-100 ${open ? 'border-l-[1px]' : 'border-l-0'}`,
      className,
    )}
    {...props}
  />
);
